// src/components/BlogHeader.js
import React from 'react';
import fallbackImage from '../images/blogbanner.png';

const BlogHeader = ({ metadata, imageUrl }) => (
  <div
    className={[
      // full-bleed on mobile; contained on md+
      'relative mx-[calc(50%-50vw)] w-screen md:mx-0 md:w-full',
      // layout/appearance
      'flex flex-col justify-center items-center text-white mb-1.5',
      'md:mt-8 md:rounded-t-2xl py-12 md:py-0',
      // height: full screen on mobile, 350px on md+
      'md:min-h-[350px]',
      // bg image handling
      'bg-no-repeat bg-cover bg-center',
      'font-roboto',
    ].join(' ')}
    style={{
      backgroundImage: `url(${imageUrl || fallbackImage})`,
    }}
  >
    <div className="max-w-4xl w-full px-4 text-center md:py-24">
      <h1 className="text-4xl sm:text-4xl md:text-4xl lg:text-6xl font-extrabold mb-6">
        {metadata.title}
      </h1>
      <p className="text-sm font-bold">By {metadata.author}</p>
      <p className="text-sm mt-1 font-bold">{metadata.date}</p>
    </div>
  </div>
);

export default BlogHeader;
